/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import { loadDropin } from "utils/DropinUtils";
import { dropinNames } from "constants/enums";
import ToolsBoardWrapper from "components/toolsBoard/ToolsBoardWrapper";
import { getConnectorType } from "app/AppInitUtility";
import { getViewerAnalyticsForKey } from "../../utils/DocumentUtils";

function ToolsBoardWrapperContainer() {
  const connectorType = getConnectorType();
  const getToolsBoardComponent = () => loadDropin(dropinNames.TOOLS_BOARD);
  return (
    <ToolsBoardWrapper
      getToolsBoardComponent={getToolsBoardComponent}
      connectorType={connectorType}
      getViewerAnalyticsForKey={getViewerAnalyticsForKey}
    />
  );
}

export default ToolsBoardWrapperContainer;
